"use client"

import { CategoryStore } from "@/types/types"
import { create } from "zustand"

export const useCategoryStore = create<CategoryStore>((set, get) => ({
  categoryMap: new Map(),
  setCategoryId: (instanceId, id) => {
    set(state => {
      const newMap = new Map(state.categoryMap)
      newMap.set(instanceId, id)
      return { categoryMap: newMap }
    })
  },
  getCategoryId: instanceId => {
    return get().categoryMap.get(instanceId) || null
  },
}))
